import axios from 'axios';
import { getLocationHeader } from '../../utils/location';

const loginUrl = process.env.REACT_APP_PORTAL_MEDICOS_LOGIN_URL;
const baseUrl = process.env.REACT_APP_PORTAL_MEDICOS_BASE_URL;
const recoverPasswordUrl =
  process.env.REACT_APP_PORTAL_MEDICOS_RECOVER_PASSWORD_URL;

export interface PortalMedicosLoginResponse {
  success: boolean;
  message: string;
  errors?: { field: string; message: string }[];
  data?: {
    exchangeUrl: string;
    expiresInSeconds: number;
  };
}

export interface PortalMedicosRecoverPasswordResponse {
  success: boolean;
  message?: string;
  errors?: { field: string; message: string }[];
}

/**
 * A API devolve o exchangeUrl como caminho relativo
 * (ex.: /api/v1/exchange?authorization_code=...), então prefixamos o host do
 * portal. URLs absolutas são mantidas como vieram.
 */
export const resolveExchangeUrl = (exchangeUrl: string): string => {
  if (/^https?:\/\//i.test(exchangeUrl)) {
    return exchangeUrl;
  }

  if (!baseUrl) {
    throw new Error(
      'A URL do Portal Médico não está configurada (REACT_APP_PORTAL_MEDICOS_BASE_URL).',
    );
  }

  return `${baseUrl.replace(/\/$/, '')}/${exchangeUrl.replace(/^\//, '')}`;
};

export const portalMedicosLogin = async (
  cpf: string,
  password: string,
): Promise<PortalMedicosLoginResponse> => {
  if (!loginUrl) {
    throw new Error(
      'A URL do Portal Médico não está configurada (REACT_APP_PORTAL_MEDICOS_LOGIN_URL).',
    );
  }

  const location = await getLocationHeader();

  const { data } = await axios.post<PortalMedicosLoginResponse>(
    loginUrl,
    {
      cpf: cpf.replace(/\D/g, ''),
      password,
    },
    location ? { headers: { 'X-Location': location } } : undefined,
  );

  return data;
};

export const portalMedicosRecoverPassword = async (
  cpf: string,
): Promise<PortalMedicosRecoverPasswordResponse> => {
  if (!recoverPasswordUrl) {
    throw new Error(
      'A URL do Portal Médico não está configurada (REACT_APP_PORTAL_MEDICOS_RECOVER_PASSWORD_URL).',
    );
  }

  const { data } = await axios.post<PortalMedicosRecoverPasswordResponse>(
    recoverPasswordUrl,
    {
      cpf: cpf.replace(/\D/g, ''),
    },
  );

  return data;
};

export default portalMedicosLogin;
